import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background: #f9efdf;
    border-radius: 8px;
    border: 1px solid #da9227; /* Corrigido o valor de border */
    padding: 16px;
    grid-template-columns: min-content 1fr auto; /* Melhor definição das colunas */
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #66491f;

    svg {
      margin-right: 8px;
      min-width: 24px;
    }

    a {
      color: ${theme.colors.primary50 ||
      '#da9227'}; /* Usando cor do tema ou cor fallback */
      text-decoration: none;
    }
    .no-margin-bottom {
      margin-bottom: 0 !important;
    }
    > p {
      word-break: break-word;
      margin: 0;
      grid-column: 2 / 3;

      @media (max-width: ${theme.breakpoints.sm || '768px'}) {
        /* Definindo um fallback para o breakpoint */
        font-size: 14px;
        grid-column: 1 / 4;
      }
    }
  `}
`;
